
export const appConfig = {
    data_session: "insuadvisor_data_sess"
};
